"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _reactNativeToastNotifications.useToast;
  }
});

var _reactNativeToastNotifications = require("react-native-toast-notifications");